import {createStore, applyMiddleware, compose, combineReducers} from "redux"
import {reducer as toastr} from "react-redux-toastr"
import Raven from "raven-js"
import createRavenMiddleware from "raven-for-redux"
import {responsiveStoreEnhancer} from "redux-responsive"
import thunkMiddleware from "redux-thunk"
import {confgureStore} from "@irati/store"
import BlockNavigationReducer from "@irati/utils/history/utils/store/reducer"
import TeamsReducer from "@irati/identity/store/reducers/Teams"
import SearchReducer from "@irati-web/search/src/store/reducers/Search"
import WalletReducer from "@irati/wallet/store/reducers/Wallet"
import WalletScheduledTransferReducer from "@irati/wallet/store/reducers/ScheduledTransfer"
import WalletStatementItemReducer from "@irati/wallet/store/reducers/StatementItem"
import GeoLocationReducer from "@irati/geolocation/src/store/reducers/GeoLocation"
import RewardAdminReducer from "@irati/reward/store/reducers/RewardAdminReducer"
import MqReducer from "./mq"
import PopUpReducer from "./PopUpReducer"

const rootReducer = combineReducers({
  mq: MqReducer,
  teams: TeamsReducer,
  popup: PopUpReducer,
  search: SearchReducer,
  toastr,
  blockNavigation: BlockNavigationReducer,
  wallet: WalletReducer,
  walletScheduledTransfer: WalletScheduledTransferReducer,
  walletStatementItem: WalletStatementItemReducer,
  reward: RewardAdminReducer,
  geoLocation: GeoLocationReducer
})

export function setupStore() {
  const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose

  /**
   * Middlewares, like `redux-thunk` that intercept or emit actions should precede `raven-for-redux`.
   */
  const store = createStore(
    rootReducer,
    composeEnhancers(
      responsiveStoreEnhancer,
      applyMiddleware(
        thunkMiddleware,
        createRavenMiddleware(Raven, {
          breadcrumbDataFromAction: (action) => ({STRING: action.str})
        })
      )
    )
  )

  confgureStore(store)
}

declare global {
  interface Window {
    __REDUX_DEVTOOLS_EXTENSION_COMPOSE__?: any
  }
}
